import { render } from "./Percentage.vue?vue&type=template&id=589c78f2&ts=true&lang=pug"
import script from "./Percentage.vue?vue&type=script&setup=true&lang=ts"
export * from "./Percentage.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__